import { renderStartMarkup } from './js/renderStartMarkup';
import './js/modal';
import './js/addFavoriteCocktail';
import './js/heroSearchByLetter';
import'./js/header/header-mobile';
import'./js/header/headerSearchByName';
import './js/createFavoritesPage'


renderStartMarkup();
